import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useStore } from "../../../app/stores/store";
import { Table, TableBody, TableCell, TableHeaderCell, TableRow, Button, Form, Header, TableFooter, Icon} from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import { toast } from 'react-toastify';
import { Capacityindividual, ClusterTenure } from '../../../app/models/Restoration';
interface ClusterCapacity {
  cluster: string;
  billable_Head_Count: number;
  month_Working_Dates: number;
  attendance: string;
  average_Efficiency: string;
  month_Capacity_Hours: number;
  month_Utilized_hours: number;
  month_Extra_Hours: number;
  month_Total_Hours: number;
  month_Remaining_Hours: number;
  per_Day_Capacity_Hours: number;
  per_Day_Average_Utilized_hours:number;
  between_Dates_Capacity_Hours: number;
  between_Dates_Utilized_hours: number;
  between_Dates_Extra_Hours: number;
  betweenDate_Total_Hours: number;
  [key: string]: string | number;
}
function ClusterCapacityReport() {
    const [loadData, setLoadData] = useState<ClusterCapacity[]>([]);
    const [tenureLoadData, setTenureLoadData] = useState<ClusterTenure[]>([]);
    const [individualLoadData,setindividualLoadData]=useState<Capacityindividual[]>([]);
    const { RestorationStore,PivotStore } = useStore();
    const currentDate = new Date();
    const [tableEnable, SetTableEnable] = useState<boolean>(false);
    const [startDate, setStartDate] = useState(() => moment(currentDate).startOf('month').format('MM-DD-YYYY'));
    const [endDate, setEndDate] = useState(() => moment(currentDate).format('MM-DD-YYYY'));
    
    const setDate = (data: any, type: string) => {
        try {
            if (type === 'start') {
                setStartDate(moment(data).format('MM-DD-YYYY'));
            } else {
                setEndDate(moment(data).format('MM-DD-YYYY'));
            }
        } catch (error) {
            toast.error('Error fetching Date');
        }
    };

    const UpdateIndualdata= async ()=>{
      await RestorationStore.IndividualClusterCapacityReport(startDate,endDate);
      await setindividualLoadData(RestorationStore.ClusterCapcityIndividualData);
      if(individualLoadData.length>0 )
        {
        const uniqueClusterNames = Array.from(new Set(individualLoadData.map(data => data.cluster)));
        const groupData=uniqueClusterNames.map(unique=>{
        const firstStatgeFilterData=individualLoadData.filter(x=>x.cluster===unique);
        const Cluster_Name=unique;
        const one_ThreeMonth = firstStatgeFilterData.filter(x => (x.tenure === 'belowFourMonths' || x.tenure === null || x.tenure === '')).reduce((sum, x) => sum + x.monthCapacityHours, 0);
        const four_SixMonth = firstStatgeFilterData.filter(x=>x.tenure==='FourPlusMonths').reduce((sum, x) => sum + x.monthCapacityHours, 0);
        const seven_twelveMonth = firstStatgeFilterData.filter(x=>x.tenure==='SixPlusMonths').reduce((sum, x) => sum + x.monthCapacityHours, 0);
        const one_TwoYears = firstStatgeFilterData.filter(x=>x.tenure==='OnePlusYears').reduce((sum, x) => sum + x.monthCapacityHours, 0);
        const two_ThreeYears = firstStatgeFilterData.filter(x=>x.tenure==='TwoPlusYears').reduce((sum, x) => sum + x.monthCapacityHours, 0);
        const three_FourYears = firstStatgeFilterData.filter(x=>x.tenure==='ThreePlusYears').reduce((sum, x) => sum + x.monthCapacityHours, 0);
        const four_FiveYears = firstStatgeFilterData.filter(x=>x.tenure==='FourPlusYears').reduce((sum, x) => sum + x.monthCapacityHours, 0);
        const five_Years = firstStatgeFilterData.filter(x=>x.tenure==='FivePlusYears').reduce((sum, x) => sum + x.monthCapacityHours, 0);
        const grand_Total= firstStatgeFilterData.reduce((sum, x) => sum + x.monthCapacityHours, 0);
      return {
        ClusterName:Cluster_Name,
        oneToThreeMonth:one_ThreeMonth,
        fourToSixMonth:four_SixMonth,
        sevenTotwelveMonth:seven_twelveMonth,
        oneToTwoYears:one_TwoYears,
        twoToThreeYears:two_ThreeYears,
        threeToFourYears:three_FourYears,
        fourFiveYears:four_FiveYears,
        fivePlusYears:five_Years,
        grandTotal:grand_Total,
      };
      });
      await setTenureLoadData(groupData);
      }
    }

    const dateBasedApiCall = async ()=> {
        try {
            SetTableEnable(true);
            setindividualLoadData([]);
            setLoadData([]);
            await RestorationStore.ClusterCapacityReport(startDate,endDate);
            await setLoadData(RestorationStore.ClusterCapcityData);
            await UpdateIndualdata();
            SetTableEnable(false);
        } catch (error) {
            console.error('Error fetching data:', error);
            toast.error('Error fetching data');
        }
    };
    useEffect(() => {
        dateBasedApiCall();
        UpdateIndualdata();
        // eslint-disable-next-line
    }, []);  

  //   useEffect(() => {
  //     if(individualLoadData.length>0 ){
  //       const uniqueClusterNames = Array.from(new Set(individualLoadData.map(data => data.cluster)));
  //     const groupData=uniqueClusterNames.map(unique=>{
  //       const firstStatgeFilterData=individualLoadData.filter(x=>x.cluster===unique);
  //       const Cluster_Name=unique;
  //       const one_ThreeMonth = firstStatgeFilterData.filter(x=>x.tenure==='belowFourMonths').reduce((sum, x) => sum + x.monthCapacityHours, 0);
  //       const four_SixMonth = firstStatgeFilterData.filter(x=>x.tenure==='FourPlusMonths').reduce((sum, x) => sum + x.monthCapacityHours, 0);
  //       const seven_twelveMonth = firstStatgeFilterData.filter(x=>x.tenure==='SixPlusMonths').reduce((sum, x) => sum + x.monthCapacityHours, 0);
  //       const one_TwoYears = firstStatgeFilterData.filter(x=>x.tenure==='OnePlusYears').reduce((sum, x) => sum + x.monthCapacityHours, 0);
  //       const two_ThreeYears = firstStatgeFilterData.filter(x=>x.tenure==='TwoPlusYears').reduce((sum, x) => sum + x.monthCapacityHours, 0);
  //       const three_FourYears = firstStatgeFilterData.filter(x=>x.tenure==='ThreePlusYears').reduce((sum, x) => sum + x.monthCapacityHours, 0);
  //       const four_FiveYears = firstStatgeFilterData.filter(x=>x.tenure==='FourPlusYears').reduce((sum, x) => sum + x.monthCapacityHours, 0);
  //       const five_Years = firstStatgeFilterData.filter(x=>x.tenure==='FivePlusYears').reduce((sum, x) => sum + x.monthCapacityHours, 0);
  //     const grand_Total= firstStatgeFilterData.reduce((sum, x) => sum + x.monthCapacityHours, 0);
  //     return {
  //       ClusterName:Cluster_Name,
  //       oneToThreeMonth:one_ThreeMonth,
  //       fourToSixMonth:four_SixMonth,
  //       sevenTotwelveMonth:seven_twelveMonth,
  //       oneToTwoYears:one_TwoYears,
  //       twoToThreeYears:two_ThreeYears,
  //       threeToFourYears:three_FourYears,
  //       fourFiveYears:four_FiveYears,
  //       fivePlusYears:five_Years,
  //       grandTotal:grand_Total,
  //     };
  //     });
  //     setTenureLoadData(groupData);
  //     }
  //     // eslint-disable-next-line
  // }, [RestorationStore.IndividualClusterCapacityReport]);  
    const getTotal = (property: keyof ClusterCapacity): number => {
        return loadData.reduce((total, item) => total + Number(item[property]), 0);
      };
      const getTenureTotal = (property: keyof ClusterTenure): number => {
        return tenureLoadData.reduce((total, item) => total + Number(item[property]), 0);
      };
      const getaverage = (property: keyof ClusterCapacity): number => {
        const total = loadData.reduce((acc, item) => acc + Number(item[property]), 0);
        const itemCount = loadData.length;
        if (itemCount === 0) return 0;
        return total / itemCount;
      };

      const getAveragePertacages = (property: keyof ClusterCapacity): string => {
        const total = loadData.reduce((acc, item) => {
          const valueStr = (item[property] || '').toString(); 
          const numericalValue = parseFloat(valueStr.replace('%', '')); 
          return acc + (numericalValue || 0); 
        }, 0);
      
        const itemCount = loadData.length;
        if (itemCount === 0) return "0%"; 
      
        const average = total / itemCount;
        return average.toFixed(0) + "%"; 
      };
      const formattedStartDate = moment(startDate, 'MM-DD-YYYY').format('DD-MMMM');
      const formattedEndDate = moment(endDate, 'MM-DD-YYYY').format('DD-MMMM');    
      const ReportMonth = moment(endDate, 'MM-DD-YYYY').format('MMM-YYYY');
      const convertToCSV = () => {
        const rows = [];
        const headerRow = [
      'Cluster',
      'Billable Head Count',
      'Month Working Dates',
      'Attendance',
      'Average Efficiency',
      'Month Capacity Hours',
      'Month Utilized Hours',
      'Month Extra Hours',
      'Month Total Hours',
      'Month Remaining Hours',
      'Per Day Capacity Hours',
      'Per Day Utilized Hours',
        ];
        rows.push(headerRow.join(','));
        loadData.forEach(item => {
            const values = Object.values(item);
            rows.push(values.join(','));
        });
        
        const footerRow = [
          'Grand Total',
          getTotal('billable_Head_Count'),
          getaverage('month_Working_Dates'),
          getAveragePertacages('attendance'),
          getAveragePertacages('average_Efficiency'),
          getTotal('month_Capacity_Hours'),
          getTotal('month_Utilized_hours'),
          getTotal('month_Extra_Hours'),
          getTotal('month_Total_Hours'),
          getTotal('month_Remaining_Hours'),
          getTotal('per_Day_Capacity_Hours'),
          getTotal('per_Day_Average_Utilized_hours'),
      ];
      rows.push(footerRow.join(','));
        const lastRow=[`****Calculate the capacity hours for the month of' ${ReportMonth} ' based on the selected From Date`];
        rows.push(lastRow.join(','));
        const csvContent = rows.join('\n');
        return csvContent;
      };
      const handleDownload = () => {
        const csvContent = convertToCSV();
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `From_${formattedStartDate}_to_${formattedEndDate}_ClusterCapacityReport.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const convertDatainttoCSV = () => {
      const rows = [];
      const headerRow = [
    'EmployeeId',
    'Employee Name',
    'Cluster',
    'Efficiency',
    'Tenure',
    'No of Working Day',
    'Attendance',
    'Capacity Hours',
    'Working Hours',
    'Extra Hours',
    'Total Hours',
    'Remaining Hours',
      ];
      rows.push(headerRow.join(','));
      individualLoadData.forEach(item => {
          const values = Object.values(item);
          rows.push(values.join(','));
      });
      
      const lastRow=[`****Calculate the capacity hours for the month of' ${ReportMonth} ' based on the selected From Date`];
      rows.push(lastRow.join(','));
      const csvContent = rows.join('\n');
      return csvContent;
    };

    const handleDataDownload = () => {
      const csvContent = convertDatainttoCSV();
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `From_${formattedStartDate}_to_${formattedEndDate}_ClusterCapacityReportData.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
  };

    return (
        <>
        <div className="title-wise-table">
            <Header>Cluster Capacity Report</Header>
            <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
                    <h4 > From Date  </h4>
                    <DatePicker
                      placeholderText="From Date"
                      value={
                        startDate
                          ? PivotStore.dateFormat(
                              moment(startDate).format('MM-DD-YYYY'),
                            )
                          : ''
                      }
                      className="date-picker-style"
                      showMonthDropdown
                      showYearDropdown
                      locale={'en'}
                      dateFormatCalendar="MMMM"
                      yearDropdownItemNumber={15}
                      // maxDate={moment().toDate()}
                      scrollableYearDropdown
                      onChange={(date: any) => setDate(date, 'start')}
                      popperProps={{ strategy: 'fixed' }}
                    />
                 </div>
            
                <Form.Field required={true}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
                      <h4> To Date{' '} </h4>
                      <DatePicker
                        placeholderText="To Date"
                        value={
                          endDate
                            ? PivotStore.dateFormat(
                                moment(endDate).format('MM-DD-YYYY'),
                              )
                            : ''
                        }
                        className="date-picker-style"
                        showMonthDropdown
                        showYearDropdown
                        locale={'en'}
                        dateFormatCalendar="MMMM"
                        yearDropdownItemNumber={15}
                        maxDate={moment(startDate).add(60, 'days').toDate()}
                        scrollableYearDropdown
                        onChange={(date: any) => setDate(date, 'end')}
                        popperProps={{ strategy: 'fixed' }}
                      />
                    </div>
                  </div>
                </Form.Field>
                <Form.Field>
                  <Button
                    primary
                    onClick={dateBasedApiCall}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      paddingRight: '20px',
                      paddingBottom: '10px',
                    }}
                  >
                    View Report
                  </Button>
                </Form.Field>
                <Form.Field>
                <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
                  {loadData.length !== 0 && (<Button onClick={handleDownload}><Icon className='download'/>Summary</Button>)}
                  </div>
              </Form.Field>
              <Form.Field>
                <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
                  {loadData.length !== 0 && (<Button onClick={handleDataDownload}><Icon className='download'/>Data</Button>)}
                  </div>
              </Form.Field>
            </div>
            <div>
              {tableEnable ? <div>
                <br/>
                <br/>
                <Header>Please Wait Cluster Capacity Summary Report Loading....</Header>
                
                </div>: 
                <Table>
                        <Table.Header>
                            <Table.Row>
                            <TableHeaderCell>Cluster</TableHeaderCell>
                            <TableHeaderCell>Billable Head Count</TableHeaderCell>
                            <TableHeaderCell>Month Working Dates</TableHeaderCell>
                            <TableHeaderCell>Attendance</TableHeaderCell>
                            <TableHeaderCell>Average Efficiency</TableHeaderCell>
                            <TableHeaderCell>Month Capacity Hours</TableHeaderCell>
                            <TableHeaderCell>Month Utilized Hours</TableHeaderCell>
                            <TableHeaderCell>Month Extra Hours</TableHeaderCell>
                            <TableHeaderCell>Month Total Hours</TableHeaderCell>
                            <TableHeaderCell>Month Remaining Hours</TableHeaderCell>
                            <TableHeaderCell>Per Day Capacity Hours</TableHeaderCell>
                            <TableHeaderCell>Per Day Utilized Hours</TableHeaderCell>
                            
                            </Table.Row>
                        </Table.Header>
                    <TableBody>
                    {loadData.length === 0 && (
                      <Table.Row>
                        <Table.Cell colSpan={16} textAlign="center">
                          Currently Data not Avaialabe
                        </Table.Cell>
                      </Table.Row>
                    )}
                        {loadData.map((item, index) => (
                            <TableRow key={index}>
                                <TableCell>{item.cluster}</TableCell>
                                <TableCell>{item.billable_Head_Count}</TableCell>
                                <TableCell>{item.month_Working_Dates}</TableCell>
                                <TableCell>{item.attendance}</TableCell>
                                <TableCell>{item.average_Efficiency}</TableCell>
                                <TableCell>{item.month_Capacity_Hours}</TableCell>
                                 <TableCell>{item.month_Utilized_hours}</TableCell>
                                <TableCell>{item.month_Extra_Hours}</TableCell>
                                <TableCell>{item.month_Total_Hours}</TableCell>
                                <TableCell>{item.month_Remaining_Hours}</TableCell>
                                <TableCell>{item.per_Day_Capacity_Hours}</TableCell>
                                <TableCell>{item.per_Day_Average_Utilized_hours}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                    {loadData.length !== 0 && (
                    <TableFooter>
                        <Table.Row>
                                <Table.HeaderCell style={{ fontWeight: 'bold' }}>Grand Total</Table.HeaderCell>
                                <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTotal('billable_Head_Count')}</Table.HeaderCell>
                                <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getaverage('month_Working_Dates')}</Table.HeaderCell>
                                <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getAveragePertacages('attendance')}</Table.HeaderCell>
                                <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getAveragePertacages('average_Efficiency')}</Table.HeaderCell>
                                <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTotal('month_Capacity_Hours')}</Table.HeaderCell>
                                <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTotal('month_Utilized_hours')}</Table.HeaderCell>
                                <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTotal('month_Extra_Hours')}</Table.HeaderCell>
                                <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTotal('month_Total_Hours')}</Table.HeaderCell>
                                <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTotal('month_Remaining_Hours')}</Table.HeaderCell>
                                <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTotal('per_Day_Capacity_Hours')}</Table.HeaderCell>
                                <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTotal('per_Day_Average_Utilized_hours')}</Table.HeaderCell>
                            </Table.Row>
                            <Table.Row>
                             <Table.Cell colSpan={16}>
                              ***Calculate the capacity hours for the month of <b>'{ReportMonth}'</b> based on the selected 'From Date'."
                            </Table.Cell>
                            </Table.Row>
                    </TableFooter>
                    )}
                </Table> 
                }
            </div>
            {individualLoadData.length !== 0 && tenureLoadData.length !== 0 && (
              <>
              <Header> Cluster Wise Tenure Report </Header>
              <Table>
                      <Table.Header>
                          <Table.Row>
                          <TableHeaderCell>Cluster Name</TableHeaderCell>
                          <TableHeaderCell>0-3 Months</TableHeaderCell>
                          <TableHeaderCell>4-6 Months</TableHeaderCell>
                          <TableHeaderCell>7- 12 Months</TableHeaderCell>
                          <TableHeaderCell>1 - 2 Years</TableHeaderCell>
                          <TableHeaderCell>2 - 3 Years</TableHeaderCell>
                          <TableHeaderCell>3 - 4 Years</TableHeaderCell>
                          <TableHeaderCell>4 - 5 Years</TableHeaderCell>
                          <TableHeaderCell>5+ Years</TableHeaderCell>
                          <TableHeaderCell>Cluster Total</TableHeaderCell>
                          </Table.Row>
                      </Table.Header>
                  <TableBody>
                  {tenureLoadData.length === 0 && (
                    <Table.Row>
                      <Table.Cell colSpan={16} textAlign="center">
                        Currently Data not Avaialabe
                      </Table.Cell>
                    </Table.Row>
                  )}
                      {tenureLoadData.map((item1, index1) => (
                          <TableRow key={index1}>
                              <TableCell>{item1.ClusterName}</TableCell>
                              <TableCell>{item1.oneToThreeMonth}</TableCell>
                              <TableCell>{item1.fourToSixMonth}</TableCell>
                              <TableCell>{item1.sevenTotwelveMonth}</TableCell>
                              <TableCell>{item1.oneToTwoYears}</TableCell>
                              <TableCell>{item1.twoToThreeYears}</TableCell>
                              <TableCell>{item1.threeToFourYears}</TableCell>
                              <TableCell>{item1.fourFiveYears}</TableCell>
                              <TableCell>{item1.fivePlusYears}</TableCell>
                              <TableCell>{item1.grandTotal}</TableCell>
                          </TableRow>
                      ))}
                  </TableBody>
                  {loadData.length !== 0 && (
                  <TableFooter>
                      <Table.Row>
                              <Table.HeaderCell style={{ fontWeight: 'bold' }}>Grand Total</Table.HeaderCell>
                              <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTenureTotal('oneToThreeMonth')}</Table.HeaderCell>
                              <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTenureTotal('fourToSixMonth')}</Table.HeaderCell>
                              <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTenureTotal('sevenTotwelveMonth')}</Table.HeaderCell>
                              <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTenureTotal('oneToTwoYears')}</Table.HeaderCell>
                              <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTenureTotal('twoToThreeYears')}</Table.HeaderCell>
                              <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTenureTotal('threeToFourYears')}</Table.HeaderCell>
                              <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTenureTotal('fourFiveYears')}</Table.HeaderCell>
                              <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTenureTotal('fivePlusYears')}</Table.HeaderCell>
                              <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTenureTotal('grandTotal')}</Table.HeaderCell>
                          </Table.Row>
                  </TableFooter>
                  )}
              </Table> 
              </>
            ) }
            </div>
        </>
    );
}

export default ClusterCapacityReport;
